import styled from 'styled-components';
import icon from '../Nav/only-icon-2.png';

export default function AnniversaryLogo() {
    return (
        <BrandStyled>
            <h1 className="name">
                <img src={icon} width="406" height="431" alt="" />
                <span>LA USINA</span>
            </h1>
            <span className="tagline">
                Espacio de formación, creación e investigación teatral
            </span>
            <a
                className="anniversary"
                href="https://revistagodot.com/20o-aniversario-de-la-usina/"
                aria-label="20 años haciendo teatro — leer el artículo en Revista Godot"
            >
                20 años haciendo teatro
            </a>
        </BrandStyled>
    );
}

const BrandStyled = styled.div`
    --brand-color: #f46d2b;
    --brand-text-color: #fff;

    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    color: var(--brand-color);
    font-family: 'Neuropol', sans-serif;
    font-weight: normal;
    text-align: center;

    .name {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: clamp(0.5rem, 1.2vw, 1rem);
        width: 100%;
        margin: 0;
        font-size: clamp(2.25rem, 6.8vw, 5.7rem);
        font-weight: normal;
        line-height: 1;
    }

    .name span {
        max-width: 100%;
        overflow-wrap: anywhere;
    }

    .name img {
        display: block;
        height: clamp(2.8rem, 8vw, 6.5rem);
        width: auto;
    }

    .tagline {
        color: var(--brand-text-color);
        font-family: 'Roboto', sans-serif;
        font-size: clamp(0.6rem, 1.2vw, 0.92rem);
        font-weight: bold;
        line-height: 1.3;
        letter-spacing: 0.035em;
        text-transform: uppercase;
    }

    .anniversary {
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 100%;
        min-height: 44px;
        padding: 0.25rem 1rem;
        border: max(2px, 0.22vw) solid var(--brand-color);
        border-radius: 10px;
        background: transparent;
        color: var(--brand-color);
        font-size: clamp(0.8rem, 2vw, 1.6rem);
        line-height: 1.3;
        text-decoration: none;
        overflow-wrap: anywhere;

        &:hover {
            color: var(--brand-text-color);
            border-color: var(--brand-text-color);
        }

        &:focus-visible {
            outline: 3px solid var(--brand-text-color);
            outline-offset: 5px;
        }
    }
`;
